/* eslint-env brwoser, es6 */
import $ from 'jquery'
import rivets from 'rivets'
import rivetsadditions from './rivets-additions'
import rivetsnouislider from './rivets-nouislider'
import ApplicationSlider from './ApplicationSlider'
import { calculateData, readProducts, convertProductsToRatedProducts, calcualteRisk} from './matrixfunctions'

export default function(dom, opts) {
	const options = {
		"appid": "upcspquiz",
		"sliderSel": ".js--slidercontainer",
		"products": null,
		"rules": null,
		"questionRules": null,
		"findMoreLink": null,
		"pdfLink": null,
		"i18l": {},
		"timeMap": ["kurz", "mittel", "lang"],
		...opts
	}

	//upgrade products to array
	var products = Object
		.keys(options.products)
		.map((key, i, arr) => {
			var p = {...options.products[key], order: arr.length - i}
			if (p["objective"] instanceof Array) {
				p["objective"] = p["objective"].join(",")
			}
			return p
		});

	const scope = {
		show: true,
		slidervalue: 1,
		currentslide: 0,
		questionCount: 6,
		navigation: {
			show: true,
			enableNext: false,
			enablePrev: false,
		},
		questions: {
			risk1: "",
			risk2: "",
			risk3: "",
			risk4: "",
			risk: "",
			objective: "",
			investmentfields: [],
			time: "",
			timeVal: 1,
		},
		overlay: {
			show: false,
		},
		riskIsSet: false,
		recommendationId: "",
		recommended: [],
		findMoreLink: "",
		pdfLink: "",
		onNextSlide: onNextSlide,
		onPrevSlide: onPrevSlide,
		onValidate: validate,
		onOverlayOpen: onOverlayOpen,
		onOverlayClose: onOverlayClose,
	}

	//bind the dom
	rivets.bind(dom, {
		scope: scope
	}, {
		formatters: {
			"ubsslideindex": function(v) {
				return v + 1
			},
			"trans": function(v) {
				var t = options.i18l[v]
				var args = [].slice.call(arguments, 1)
				if (t) {
					if (args.length) {
						args.reduce((p,c,i) => p.replace("${"+i+"}", args[i]), t)
					}
					return t
				}
				return "NT-" + v
			}
		}
	})

	//initialize code
	let startSlide = 0

	//enable history set with navigation
	if (location.hash.indexOf("#/result") == 0) {
		var spl=location.hash.split("/");
		if (spl.length > 2) {
			var urlAnswers = readHashInput(spl);
			if (urlAnswers) { //check if it is valid input
				Object.assign(scope.questions, urlAnswers);
				startSlide = 6
			}
		} else {
			Object.assign(scope.questions, {"risk":"hochmittleresrisiko","objective":"absicherungbestehenderpositionen","investmentfields":["fx","equity"],"timeVal":1, "time":"kurz"});
			startSlide = 6
		}

	}

	const slider = new ApplicationSlider()
	slider.init({
		context: $(options.sliderSel ,dom),
		slides: ">section",
		onSlideChange: onSlideChange,
		startSlide
	})

	window.quizzapp = {
		slider,
		scope,
	}

	onSlideGoto(startSlide);

	//functions
	function onNextSlide() {
		//skip risk choose slide
		onSlideGoto(scope.currentslide+1)
	}

	function onPrevSlide() {
		onSlideGoto(scope.currentslide-1)
	}

	function onSlideGoto(nr) {
		let currentIndex = scope.currentslide
		scope.currentslide = nr;
		slider.goto(nr)
	}

	function onSlideChange(slider,newindex,oldindex) {

		if ((slider.slides.length-1) == newindex) {
			//prepare last slide
			scope.navigation.show = false;

			//build filterlist
			let filterList = []

			let risk = scope.questions.risk
			
			if (risk == "" && scope.questions.risk1) {
				risk = calcualteRisk([scope.questions.risk1, scope.questions.risk2, scope.questions.risk3], options.questionRules)
			}

			filterList.push(["time", scope.questions.time])
			filterList.push(["risk", risk])
			filterList.push(["objective", scope.questions.objective])
			scope.questions.investmentfields.forEach(f => filterList.push(["investment", f]))

			//calculate rated products
			const prepProducts = convertProductsToRatedProducts(products)
			const ratedProducts = calculateData(prepProducts, options.rules, filterList)

			if (ratedProducts.length) {
				scope.recommendationId = ratedProducts[0].product.id

				scope.recommended = ratedProducts.slice(0, 3)
					.map(p => ({ ...p.product }))
			} else {
				//if this happens, something is logically wrong
				console.error("No Matching Product found.")
			}

			//risk
			scope.questions.risk = risk

			window.location.hash = "#/result/" + [
				"objective",
				"investmentfields",
				"time",
				"risk"
			].map(function(v) {
				var val = scope.questions[v];
				if (val instanceof Array) {
					return v+"/"+val.join(",");
				} else {
					return v+"/"+val;
				}
			})
			.join("/");


			//pdf link
			scope.pdfLink = options.pdfLink + "?" + [
				"objective",
				"investmentfields",
				"time",
				"risk"
			].map(function(v) {
				var val = scope.questions[v];
				if (val instanceof Array) {
					return v+"="+val.join(",");
				} else {
					return v+"="+val;
				}
			})
			.concat(["products="+ratedProducts.slice(0, 3).map(p => p.product.id)])
			.join("&")

			//display link
			scope.findMoreLink = options.findMoreLink + "#/filter/" + filterList
				.map((f) => f[0] + "=" + f[1])
				.join("&")
				+"/recommend/"+scope.recommendationId
		} else {
			scope.navigation.show = true;
		}

		validate()
	}
	function validate() {
		var enableNext = false;
		var enablePrev = false;

		scope.questions.time = options.timeMap[scope.questions.timeVal-1] //zero index vs no-zero number

		//enable prev button
		if (scope.currentslide != 0) {
			enablePrev = true;
		}
		if (scope.currentslide == 0) {
			if (scope.questions.risk1) {
				enableNext = true;
			}
		} else if (scope.currentslide == 1) {
			if (scope.questions.risk2) {
				enableNext = true;
			}
		} else if (scope.currentslide == 2) {
			if (scope.questions.risk3) {
				enableNext = true;
			}
		} else if (scope.currentslide == 3) {
			if (scope.questions.investmentfields.length) {
				enableNext = true;
			}
		} else if (scope.currentslide == 4) {
			if (scope.questions.objective) {
				enableNext = true;
			}
		} else if (scope.currentslide == 5) {
			if (scope.questions.investmentfields.length) {
				enableNext = true;
			}
		} else if (scope.currentslide == 6) {
			enableNext = true;
		}

		scope.navigation.enableNext = enableNext;
		scope.navigation.enablePrev = enablePrev;
	}

	function onOverlayOpen() {
		$(document).triggerHandler("OVERLAY_OPEN");
		scope.overlay.show = true;

	}

	function onOverlayClose() {
		$(document).triggerHandler("OVERLAY_CLOSE");
		scope.overlay.show = false;
	}

	function readHashInput(spl) {
		var urlAnswers = {};
		for (var i=2, ilen=spl.length; i<ilen; i+=2) {
			var val = spl[i+1];
			switch(spl[i]) {
				case "risk":
					if (options.filterData.risk.filter((v) => v.title == val).length == 1) {
						urlAnswers.risk = val
					}
					break;
				case "investmentfields":
					let investVal = val.split(",");
					if (
						investVal.length < 5 
						&& options.filterData.investment.filter(v => investVal.indexOf(v.title) >= 0).length == investVal.length
					) {
						urlAnswers.investmentfields = investVal;
					}
					break;
				case "time":
					let timeVal = options.timeMap.indexOf(val) +1;
					if (timeVal > 0) {
						urlAnswers.time = val;
						urlAnswers.timeVal = timeVal;
					}
					break;
				case "objective":
					if (options.filterData.objective.filter(v => val == v.title).length == 1) {
						urlAnswers.objective = val;
					}
					break;
			}
		}
		
		if (Object.keys(urlAnswers).length == 5) { //check if it is valid input
			return urlAnswers;
		}
		return null;
	}
}
